import { AppProvider } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import ExperienceSection from "./components/sections/ExperienceSection";
import Projects from "./components/sections/Projects";
import Skills from "./components/sections/Skills";
import AppliedAI from "./components/sections/AppliedAI";
import Process from "./components/sections/Process";
import Contact from "./components/sections/Contact";

function App() {
  return (
    <AppProvider>
      <Navbar />
      <main>
        <Hero />
        <About />
        <ExperienceSection />
        <Projects />
        <Skills />
        <AppliedAI />
        <Process />
        <Contact />
      </main>
      <Footer />
    </AppProvider>
  );
}

export default App;
